import { render } from "./CompletionOrders.vue?vue&type=template&id=1caf52f1&scoped=true"
import script from "./CompletionOrders.vue?vue&type=script&lang=js"
export * from "./CompletionOrders.vue?vue&type=script&lang=js"

import "./CompletionOrders.vue?vue&type=style&index=0&id=1caf52f1&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1caf52f1"]])

export default __exports__